import React from "react";

const passwordConfirmation = (value, props, components) => {
  if (value !== components["password"][0].value) {
    return <div role="alert">Passwords don't match</div>;
  }
};

export default passwordConfirmation;
